import * as React from "react";
import * as moment from "moment";
import * as _ from "underscore";

import { PropertyRepairShape } from "@eave/shared/types/api";
import Money from "../../../Money";

const classnames = require("classnames");
const humanize = require("underscore.string/humanize");
const { OverlayTrigger, Popover } = require("react-bootstrap");

const EMDASH = <span className="property-condition__emdash">—</span>;

interface RepairTableProps {
  prefix: string;
  repairs: {
    map: Function;
    length: number;
    [index: number]: PropertyRepairShape;
  };
  confirmedComplete: {
    map: Function;
    length: number;
    [index: number]: {
      id: number;
      seller_fix_confirmed_complete: boolean;
    };
  };
  showSellerFix?: boolean;
  onToggleFixCompleted?: Function;
}

class RepairTable extends React.Component<RepairTableProps, any> {
  constructor(props) {
    super(props);

    // assumption is that we'll have three fields for each prefix:
    // -- in_<prefix>
    // -- <prefix>_cost_to_cure
    // -- <prefix>_note

    if (props.prefix !== "appraisal" && props.prefix !== "inspection") {
      throw new Error("prefix must be either 'appraisal' or 'inspection'");
    }
  }

  renderSellerFixOverlay(r) {
    const date = r.seller_fix_estimated_date
      ? moment.utc(r.seller_fix_estimated_date).format("YYYY-MM-DD")
      : EMDASH;

    return (
      <Popover id="pop">
        <table className="property-condition__popover-table">
          <tbody>
            <tr>
              <td>
                <strong>Description:</strong>
              </td>
              <td className="property-condition__popover-table-value">
                {r.seller_fix_description || EMDASH}
              </td>
            </tr>
            <tr>
              <td>
                <strong>Estimated date:</strong>
              </td>
              <td className="property-condition__popover-table-value">{date}</td>
            </tr>
            <tr>
              <td>
                <strong>Seller completed?</strong>
              </td>
              <td className="property-condition__popover-table-value">
                {r.seller_fix_reported_complete ? <i className="fa fa-check" /> : EMDASH}
              </td>
            </tr>
          </tbody>
        </table>
      </Popover>
    );
  }

  render() {
    const { prefix, repairs, showSellerFix, onToggleFixCompleted } = this.props;

    const filtered = _.chain(repairs)
      .filter((r: any) => r[`in_${prefix}`])
      .sortBy((r: any) => -1 * parseFloat(r[`${prefix}_cost_to_cure`]))
      .sortBy((r: any) => (r.eligible ? 1 : 0)) // prioritize ineligible
      .value();

    return (
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>{humanize(prefix)} repair</th>
            <th className="text-center">Eligible</th>
            <th>Note</th>
            <th className="text-right">Cost to cure</th>
            {showSellerFix && <th className="text-center">Seller fix</th>}
            {showSellerFix && <th className="text-center">Fix OK?</th>}
          </tr>
        </thead>
        <tbody>
          {filtered.map((r: any) => {
            const confirmed = _.findWhere(this.props.confirmedComplete, {
              id: r.id,
            }).seller_fix_confirmed_complete;

            const confirmedClasses = classnames({
              fa: true,
              "fa-square-o": !confirmed,
              "fa-check-square-o": confirmed,
            });

            return (
              <tr key={r.repair_type}>
                <td>{r.description}</td>
                <td className="text-center">
                  {r.eligible ? (
                    <i className="fa fa-check property-condition__repair--eligible" />
                  ) : (
                    <i className="fa fa-times property-condition__repair--ineligible" />
                  )}
                </td>
                <td>{r[`${prefix}_note`] || EMDASH}</td>
                <td className="text-right">
                  <Money value={r[`${prefix}_cost_to_cure`]} />
                </td>
                {showSellerFix && (
                  <td className="text-center">
                    <OverlayTrigger placement="left" overlay={this.renderSellerFixOverlay(r)}>
                      <i className="fa fa-search-plus" />
                    </OverlayTrigger>
                  </td>
                )}
                {showSellerFix && (
                  <td
                    className="property-condition__clickable text-center"
                    onClick={onToggleFixCompleted.bind(this, r.id)}
                  >
                    <i className={confirmedClasses} />
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default RepairTable;
